<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import { parseUrl } from "$lib/utils/helpers";
  import Image from "$lib/atoms/Image.svelte";

  export let blok;
  export let layout: "normal" | "compact" = "normal";
</script>

<div class="text-image-slide" use:storyblokEditable={blok}>
  {#if layout === "compact"}
    <div class="media compact relative !bg-sand">
      <h6 class="type:h4 pt-[20px] pl-[20px] relative z-20">{blok.title}</h6>
      <Image
        class="!absolute mt-[10px] sm:mt-[30px] top-0 right-0 bottom-0 left-0 opacity-0 hover:opacity-100 z-10 transition-opacity layout-compact"
        media={blok.hoverMedia}
        lgSize="30"
        smSize="80"
        contain
      />
      <Image
        class="!absolute mt-[10px] sm:mt-[30px] top-0 right-0 bottom-0 left-0 z-0 layout-compact"
        media={blok.media}
        lgSize="30"
        smSize="80"
        contain
      />
    </div>
    <p class="type:body-medium pt-[16px]">{blok.text}</p>
    {#if blok.link && blok.linkText}
      <p><a class="slide-link" href={parseUrl(blok.link)}>{blok.linkText}</a></p>
    {/if}
  {:else}
    <div class="media">
      <Image aspect="1" lgSize="30" media={blok.media} smSize="100" />
    </div>
    <div class="content">
      <h6 class="type:h6-large">{blok.title}</h6>
      <p class="type:body-medium">{blok.text}</p>
    </div>
  {/if}
</div>

<style lang="scss">
  .media {
    background: #eeeeee;
    border-radius: 6px;

    &.compact {
      aspect-ratio: 265/325;
      @include breakpoint("medium") {
        aspect-ratio: 350/400;
      }
    }
  }

  .content {
    margin-top: fluid(32px, 24px);
    padding-right: fluid(4px);

    h6 {
      margin-bottom: em(16px, 20px);
    }
  }

  .slide-link {
    font-weight: var(--font-weight-semibold);
    color: #4b4b4b;
  }
</style>
